import 'Styles/templates/page.scss';
import TableResponsive from '../vue/table-responsive';

TableResponsive();
